import RoomSelect from '../../views/rooms/RoomSelect';
import ZoneSelect from '../../views/rooms/ZoneSelect';
import TypeSelect from "../../views/rooms/TypeSelect";
import AddressSelect from "../../views/rooms/AddressSelect";

export default [
    {
        path: '/locali',
        name: 'rooms',
        component: RoomSelect,
        props: true,
        meta: {showNav: false, showOptionbar: false}
    },
    {
        path: '/locali/servizi',
        name: 'rooms.type',
        component: TypeSelect,
        meta: {showNav: false, showOptionbar: false}
    },
    {
        path: '/locali/zone',
        name: 'rooms.zone',
        component: ZoneSelect,
        meta: {showNav: false, showOptionbar: false}
    },
    {
        path: '/locali/indirizzo',
        name: 'rooms.address',
        component: AddressSelect,
        meta: {showNav: false, showOptionbar: false}
    },
]
